export const CONSENT_KEY = "myapp_consent_v1";

export function setConsent(value: boolean) {
  localStorage.setItem(CONSENT_KEY, value ? "accepted" : "declined");
}

export function getConsent(): "accepted" | "declined" | null {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === "accepted" || value === "declined") return value;
    return null;
  }